export default __webpack_public_path__ + "static/media/roadmap_left.86b6283b.png";